<template>
    <div class="password-form-group">
        <v-text-field
            :label="placeholderText"
            :value="value"
            @input="$emit('input', $event)"
            :type="show ? 'text' : 'password'"
            :readonly="readonly"
            required
        >
        </v-text-field>
        <v-btn-toggle v-model="text">
            <v-btn flat color="dark" @click="show = !show">
                {{ buttonText }}
            </v-btn>
            <v-btn
                flat
                color="dark"
                @click="generate"
                loader="loading"
                :disabled="loading"
            >
                {{ $t('form.button.generate') }}
            </v-btn>
        </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'password',

    props: [
        'fetchUrl',
        'value',
        'type',
        'labelText',
        'readonly',
        'onLoadGenerate',
    ],

    data() {
        return {
            text: false,
            loading: false,
            show: false,
        }
    },

    computed: {
        inputType() {
            let type = this.type || 'text'

            return this.show ? type : 'password'
        },

        buttonText() {
            return this.show
                ? this.$t('form.button.hide')
                : this.$t('form.button.show')
        },

        placeholderText() {
            return this.labelText
        },
    },

    methods: {
        async generate() {
            if (this.onLoadGenerate) {
                this.loading = true

                let { data } = await this.$http.get(this.fetchUrl)

                this.$emit('input', data)

                this.loading = false
            }
        },
    },
}
</script>

<style>
.password__show {
    border-right: 1px solid #dae4e9 !important;
}
</style>
